import { apiAdminInstance } from "../Api/ApiInstance";
import { string_to_slug } from "../helpers/Strings";

export const CreateFrontBrake = async (frontBrake) => {
  let { nombre_freno_delantero } = frontBrake;
  const slug = string_to_slug(nombre_freno_delantero);

  return await apiAdminInstance.post("api/nexus-main/frontBrake/", {
    nombre_freno_delantero,
    slug,
    state: 1,
  });
};

export const ListFrontBrakes = async () => {
  return await apiAdminInstance.get("api/nexus-main/frontBrake/");
};

export const ListFrontFilter = async () => {
  return await apiAdminInstance.get("api/nexus-main/frontBrake/filter");
};

export const UpdateFrontBrake = async (frontBrake) => {
  const { id, nombre_freno_delantero, state } = frontBrake;
  const slug = nombre_freno_delantero ? string_to_slug(nombre_freno_delantero) : nombre_freno_delantero;

  return await apiAdminInstance.put("api/nexus-main/frontBrake/" + id, {
    nombre_freno_delantero,
    slug,
    state,
  });
};

export const DeleteFrontBrake = async (id) => {
  return await apiAdminInstance.delete("api/nexus-main/frontBrake/" + id);
};
